module.exports = __webpack_public_path__ + "img/GH-kyujin-top-014.cb5633b4.webp";